import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';
import { NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX } from '~constants/filters';
import { downloadFile } from '~utils/utilFunctions';

interface TimesheetImageHeaderProps {
  fileUrl: string | null;
  isBusy: boolean;
  timesheetNumber: string | null;
}

export default function TimesheetImageHeader({
  fileUrl,
  isBusy,
  timesheetNumber,
}: TimesheetImageHeaderProps) {
  if (!fileUrl && !timesheetNumber) {
    return null;
  }

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        gap: 2,
        height: `${NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX}px`,
        mb: 2,
      }}
    >
      {timesheetNumber && (
        <Typography
          sx={{
            fontSize: '16px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          <Typography
            component="span"
            sx={(theme) => ({
              color: theme.brandV2.colors.treadGray2,
              fontSize: 'inherit',
            })}
          >
            {t('approvals.timesheets.drawer_title')}
          </Typography>
          <Typography
            component="span"
            sx={(theme) => ({
              color: theme.brandV2.colors.treadBlack,
              fontSize: 'inherit',
              fontWeight: 600,
              ml: 0.5,
            })}
          >
            {timesheetNumber}
          </Typography>
        </Typography>
      )}

      {fileUrl && (
        <SmallButton
          color="inherit"
          disabled={isBusy}
          onClick={() => downloadFile(fileUrl, fileUrl, true)}
          startIcon={<FileDownloadOutlined />}
          variant="outlined"
          sx={(theme) => ({
            bgcolor: 'background.paper',
            border: `solid 1px ${theme.brandV2.colors.treadGray7}`,
            ml: 'auto',
          })}
        >
          {t('approvals.files.download_image_cta')}
        </SmallButton>
      )}
    </Box>
  );
}
